"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRouter = require("react-router");

var _filters = require("../../../utils/lib/filters");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ClearButton = function ClearButton(values, clearFilters) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    color: "red",
    disabled: (0, _lodash.isEmpty)(values),
    id: "clear-filters",
    content: "Clear",
    onClick: clearFilters,
    style: {
      height: '38px',
      marginTop: '24px'
    }
  });
};

var Filters = function Filters(_ref) {
  var _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      filterColumn = _ref.filterColumn,
      values = _ref.values,
      clearFilters = _ref.clearFilters,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? true : _ref$inline,
      hideClearButton = _ref.hideClearButton,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? 'compact-filters' : _ref$classes;
  return filters.length ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
    compact: inline,
    basic: inline,
    className: "".concat(classes, " ").concat(inline && 'inline-filters')
  }, !inline && /*#__PURE__*/_react["default"].createElement("h3", null, "Filter by:"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, null, inline && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "filter"
  }), filters.map(function (_ref2, index) {
    var onChange = _ref2.onChange,
        component = _ref2.component,
        filterOpts = (0, _objectWithoutProperties2["default"])(_ref2, ["onChange", "component"]);
    // onChange is sometimes not set or undefined..
    var customOnChange = onChange ? {
      onChange: onChange(filterColumn)
    } : {};

    var props = _objectSpread(_objectSpread({
      key: (0, _lodash.get)(filterOpts, 'id', index),
      control: component
    }, customOnChange), {}, {
      value: (0, _lodash.get)(values, filterOpts.name, '')
    }, filterOpts);

    var checkboxProps = {
      checked: (0, _lodash.get)(values, filterOpts.name, 'false') === 'false' ? false : (0, _lodash.get)(values, filterOpts.name)
    };

    if ((0, _lodash.get)(component, 'name', '').includes('Checkbox')) {
      props = _objectSpread(_objectSpread({}, props), checkboxProps);
    }

    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, props);
  }), inline && !hideClearButton && ClearButton(values, clearFilters))), !inline && !hideClearButton && ClearButton(values, clearFilters)) : '';
};

var _default = function _default(Component) {
  var _temp;

  var wrapper = (_temp = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(FilteredTable, _React$Component);

    var _super = _createSuper(FilteredTable);

    function FilteredTable() {
      var _this;

      (0, _classCallCheck2["default"])(this, FilteredTable);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        filtered: []
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateURL", function (id, value) {
        var urlParams = (0, _filters.filteredArrayToObject)(_this.state.filtered);
        var params = new URLSearchParams({}); // over here we need to iterate over the url params and have custom params handling for arrays

        Object.keys(urlParams).map(function (key) {
          // if the value of the param is an array then add a new search paramter to the URLSearchParam
          if (Array.isArray(urlParams[key])) {
            urlParams[key].forEach(function (item) {
              params.append(key, item);
            });
          } else {
            // if it's not an array just add the value to the param as usual
            params.append(key, urlParams[key]);
          }
        });

        _this.props.history.replace(_objectSpread(_objectSpread({}, _this.props.history.location), {}, {
          search: "".concat(params.toString())
        })); // the function passed into this component as a call back from the rendering component.


        if (typeof _this.props.onFilterChange === 'function') {
          _this.props.onFilterChange(id, value);
        }
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterColumn", function (id, value) {
        var op = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'match';
        var newfilter = {
          id: id,
          value: value,
          op: op
        };

        var filtersWhithoutNew = _this.state.filtered.filter(function (item) {
          return item.id !== id;
        });

        _this.setState({
          filtered: filtersWhithoutNew.concat(value ? [newfilter] : [])
        }, function () {
          return _this.updateURL(id, value);
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearURL", function () {
        _this.props.history.replace(_objectSpread(_objectSpread({}, _this.props.history.location), {}, {
          search: ''
        }));
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearFilters", function () {
        _this.setState({
          filtered: []
        }, function () {
          return _this.clearURL();
        });
      });
      return _this;
    }

    (0, _createClass2["default"])(FilteredTable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$defaultFi = this.props.defaultFilters,
            defaultFilters = _this$props$defaultFi === void 0 ? [] : _this$props$defaultFi; // Search as soon as it is mounted !!

        var params = new URLSearchParams(this.props.location.search);
        var urlFilters = (0, _filters.paramsToObject)(params); // always override default filters with the URL filters

        var uniqueDefaultFilters = (0, _lodash.filter)(defaultFilters, function (f) {
          return !(0, _lodash.find)(urlFilters, {
            id: f.id
          });
        });
        var paramsObjArray = [].concat((0, _toConsumableArray2["default"])(uniqueDefaultFilters), (0, _toConsumableArray2["default"])(urlFilters)); // if there's a filterable object already there, add the new one to it as an array

        var filtered = (0, _lodash.reduce)(paramsObjArray, function (acc, curr) {
          var foundIndex = (0, _lodash.findIndex)(acc, function (item) {
            return item.id === curr.id;
          });

          if (foundIndex === -1) {
            acc.push(curr);
          } else if (Array.isArray(acc[foundIndex].value)) {
            acc[foundIndex].value = [].concat((0, _toConsumableArray2["default"])(acc[foundIndex].value), [curr.value]);
          } else {
            acc[foundIndex].value = [acc[foundIndex].value, curr.value];
          }

          return acc;
        }, []);
        this.setState({
          filtered: filtered
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props$filters = this.props.filters,
            filters = _this$props$filters === void 0 ? [] : _this$props$filters;
        var filteredFilters = filters.filter(function (filter) {
          return filter.hasOwnProperty('show') ? filter.show : true;
        });
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(Filters, (0, _extends2["default"])({
          filters: filteredFilters,
          clearFilters: this.clearFilters,
          filterColumn: this.filterColumn,
          values: (0, _filters.filteredArrayToObject)(this.state.filtered)
        }, this.props.filterComponentProps)), /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, this.props, {
          filtered: this.state.filtered
        })));
      }
    }]);
    return FilteredTable;
  }(_react["default"].Component), _temp);
  return (0, _reactRouter.withRouter)(wrapper);
};

exports["default"] = _default;